import React from "react"
import { AppBar, Grid, Hidden, IconButton, Toolbar } from "@material-ui/core"
import { Menu } from "@material-ui/icons"
import NavProfile from "./NavProfile"
import { Link } from "react-router-dom"
import useStyles from "../../hooks/useStyles"
export default function Header(props) {
    const classes = useStyles()
    const { handleDrawerToggle } = props
    return (
        <AppBar position="fixed" color="default" className={classes.appBar}>
            <Toolbar variant="dense">
                <Hidden mdUp implementation="css">
                    <IconButton edge="start" onClick={()=>handleDrawerToggle(true)}>
                        <Menu />
                    </IconButton>
                </Hidden>
                <Hidden smDown implementation="css">
                    <IconButton edge="start" onClick={()=>handleDrawerToggle(false)}>
                        <Menu />
                    </IconButton>
                </Hidden>
                <Grid item xs className={classes.title}>
                    <Link to="/">
                        <img src="../img/logo.svg" alt="Flexia" style={{ height: '1.5rem' }} />
                    </Link>
                </Grid>
                <NavProfile />
            </Toolbar>
        </AppBar>
    )
}